import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DialogContent, Typography } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import StarBorderRoundedIcon from "@material-ui/icons/StarBorderRounded";
import clsx from "clsx";
import { HQModal } from "../HQModal";
import * as colors from "../../../theme/colors";
import BlockJamLogo from "../../../images/BlockJam_logo.svg";
import BlockJamCard from "./blockJamCard";
import { AppRoutes } from '../../../constants';

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: "0px 15px 15px 15px",
    maxWidth: 470,
  },
  logoWrapper: {
    display: "flex",
    marginBottom: 15,
  },
  subtitle: {
    fontSize: 13,
    color: colors.grey600,
    marginBottom: 20,
    lineHeight: 1.5,
    textAlign: "left",
  },
  gridWrapper: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
    },
  },
  codeJamLogo: {
    width: 140,
    maxHeight: 40,
  },
  icon: {
    fontSize: 26,
  },
  searchIcon: {
    color: colors.darkGreen,
  },
  starIcon: {
    color: '#006085', //Used only here, not part of UIKit, will be removed with component on TextJam Phase 2
  },
  searchIconWrapper: {
    backgroundColor: colors.blueGreen,
  },
  starIconWrapper: {
    backgroundColor: '#DFF6FF', //Used only here, not part of UIKit, will be removed with component on TextJam Phase 2
  },
  wrapper: {
    marginTop: 20,
  },
}));

const BlockJamModal = ({ isOpen, onClose, push }) => {
  const classes = useStyles();

  return (
    <HQModal
      title="Start Coding!"
      isOpen={isOpen}
      onClose={onClose}
      titleOptions={{ isUpperCase: false, isBold: false }}
      withoutAutofocus
      dialogContentStyles={classes.dialogContent}
    >
      <DialogContent className={classes.dialogContent}>

        <div className={classes.logoWrapper}>
          <img
            alt="CodeJam Logo"
            className={classes.codeJamLogo}
            src={BlockJamLogo}
          />
        </div>

        <Typography className={classes.subtitle}>
          Drag and drop code blocks in BlockJam to build cool projects and level up your coding skills!
        </Typography>

        <div className={classes.gridWrapper}>
          <BlockJamCard
            title="Find a Project"
            text="Go to the Projects page and start a new curriculum activity."
            icon={<SearchIcon className={clsx(classes.icon, classes.searchIcon)} />}
            iconWrapperClass={classes.searchIconWrapper}
            buttonLabel="Start Exploring"
            onClick={() => { onClose(); push(`${AppRoutes.MY_PROJECTS}`); }}
          />

          <BlockJamCard
            title="Playground"
            text="Want to start from scratch? Open the Playground and create your own project."
            icon={<StarBorderRoundedIcon className={clsx(classes.icon, classes.starIcon)} />}
            iconWrapperClass={classes.starIconWrapper}
            buttonLabel="Build Now"
            onClick={() => { onClose(); push(`${AppRoutes.BLOCK_JAM}/playground`); }}
          />
        </div>
      </DialogContent>
    </HQModal>
  );
};

export default BlockJamModal;
